import { DealsSection } from "@/types/deals.types";
import {
  TableCreatorTableList,
  TableCreatorSubGroupShellTableList,
} from "@FillInTableContainer/shared/types/tableCreator.types";

interface DealsKeyCommentLayout {
  groupTableKey: DealsSection;
  tableList: TableCreatorTableList;
}

interface DealsKeyCommentMaLayout {
  groupTableKey: DealsSection;
  tableList: TableCreatorSubGroupShellTableList;
}

export const DEALS_KEY_COMMENT_GROUP_TABLE_LAYOUT: DealsKeyCommentLayout = {
  groupTableKey: "Key Comment",
  tableList: [
    {
      tableKey: null,
      groupShellList: [
        {
          groupShellKey: null,
          shellList: [
            {
              shellKey: "Quote",
            },
            {
              shellKey: "Spokesperson",
            },
          ],
        },
      ],
    },
  ],
};

export const DEALS_MA_KEY_COMMENT_LIST_GROUP_TABLE_LAYOUT: DealsKeyCommentMaLayout =
  {
    groupTableKey: "Key Comment List",
    tableList: [
      {
        tableKey: null,
        groupShellList: [
          {
            groupShellKey: null,
            subGroupShellList: [
              {
                subGroupShellKey: "Key Comment List",
                shellList: [
                  {
                    shellKey: "Comment Quote",
                  },
                  {
                    shellKey: "Comment Spokesperson",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };
